import { VehicleType } from 'gql/generated/graphql'
import { defineMessages } from 'react-intl'

export const vehicleTypeMessages = defineMessages({
  [VehicleType.Bus]: {
    id: 'vehicle.type.bus',
    defaultMessage: 'Bus'
  },
  [VehicleType.Van]: {
    id: 'vehicle.type.van',
    defaultMessage: 'Van'
  },
  [VehicleType.Sedan]: {
    id: 'vehicle.type.sedan',
    defaultMessage: 'Sedan'
  },
  [VehicleType.Suv]: {
    id: 'vehicle.type.suv',
    defaultMessage: 'SUV'
  }
})
